import { createAction, props } from '@ngrx/store';
import { PriorityRating } from '@capital-access/targeting/common';
import { CustomTarget } from '../../models/custom-target.model';

export const openCustomizeTargetDrawer = createAction(
  scoped`Open Customize Target Drawer`,
  props<{ targetCompany: CustomTarget }>()
);

export const confirmEditTarget = createAction(
  scoped`Confirm Edit Target`,
  props<{ targetCompany: CustomTarget; priorityRating: PriorityRating }>()
);
export const saveEditTarget = createAction(
  scoped`Save Edit Target`,
  props<{ targetCompany: CustomTarget; priorityRating: PriorityRating }>()
);
export const editTargetSuccess = createAction(scoped`Edit Target Success`, props<{ targetCompany: CustomTarget }>());
export const editTargetFailure = createAction(scoped`Edit Target Failure`);
export const confirmResetRating = createAction(scoped`Confirm Reset Rating`, props<{ targetCompany: CustomTarget }>());
export const confirmResetRatingsInBulk = createAction(
  scoped`Confirm Reset Ratings In Bulk`,
  props<{ selectedIds: number[] }>()
);
export const resetRating = createAction(scoped`Reset Rating`, props<{ targetCompany: CustomTarget }>());
export const resetRatingsInBulk = createAction(scoped`Reset Ratings In Bulk`, props<{ selectedIds: number[] }>());
export const resetRatingSuccess = createAction(scoped`Reset Rating Success`, props<{ targetCompany: CustomTarget }>());
export const resetRatingsInBulkSuccess = createAction(
  scoped`Reset Ratings In Bulk Success`,
  props<{ selectedIds: number[] }>()
);
export const resetRatingFailure = createAction(scoped`Reset Rating Failure`);

function scoped(templateString: TemplateStringsArray) {
  return '[CustomTarget] ' + templateString[0];
}
